// needed for row & cell level scope DnD setup
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Header, flexRender, Table } from "@tanstack/react-table";
import { PanTool as PanToolIcon } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import classes from "./DraggableTableHeader.module.scss";
import {
  TiArrowSortedUp,
  TiArrowSortedDown,
  TiArrowUnsorted,
} from "react-icons/ti";
import type { ComponentType } from "react";
import { CSSProperties } from "react";
import { Filter } from "../filter/Filter";
import { colorSelect } from "../../../commons/columnColor";
import {
  backColorTableHeader,
  backColorTableRowEven,
  backgroundColor,
} from "../../../commons/colors";
import { useRecoilValue } from "recoil";
import { userState } from "../../../states/userState";
// type Post = {
//   userId: number;
//   id: number;
//   title: string;
//   body: string;
//   url: Array<Url>;
// };
type Url = {
  name: string;
  url: string;
};

const SortArrowUp = TiArrowSortedUp as unknown as ComponentType;
const SortArrowDown = TiArrowSortedDown as unknown as ComponentType;
const SortArrowUnset = TiArrowUnsorted as unknown as ComponentType;

export const DraggableTableHeader = ({
  header,
  table,
}: {
  header: Header<any, any>;
  table: Table<any>;
}) => {
  const { attributes, isDragging, listeners, setNodeRef, transform } =
    useSortable({
      id: header.column.id,
    });
  // console.log("headerSize", header.column.getSize());
  const user = useRecoilValue(userState);
  const colorStyle = colorSelect(header.column.columnDef.id ?? "");
  // console.log(colorStyle);
  const styleBase: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: "relative",
    transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
    transition: "width transform 0.2s ease-in-out",
    whiteSpace: "nowrap",
    width: header.column.getSize(),
    maxWidth: header.column.getSize(),
    minWidth: header.column.getSize(),

    zIndex: isDragging ? 1 : 0,
  };
  // const styleProcess: CSSProperties = {
  //   opacity: isDragging ? 0.8 : 1,
  //   position: "relative",
  //   transform: CSS.Translate.toString(transform), // translate instead of transform to avoid squishing
  //   transition: "width transform 0.2s ease-in-out",
  //   whiteSpace: "nowrap",
  //   width: header.column.getSize(),
  //   maxWidth: header.column.getSize(),
  //   minWidth: header.column.getSize(),
  //   color: "#5865F2",
  //   zIndex: isDragging ? 1 : 0,
  // };

  return (
    <th colSpan={header.colSpan} ref={setNodeRef} style={styleBase}>
      <div className={classes.headerContents} {...attributes} {...listeners}>
        {/* <div className={classes.headers} {...attributes} {...listeners}> */}
        <div
          className={classes.headers}
          style={backColorTableHeader(user?.mode ?? "lite")}
          onClick={header.column.getToggleSortingHandler()}
        >
          <div className={classes.dragIcon}>
            <PanToolIcon
              sx={
                colorStyle === "base"
                  ? { fontSize: "16px", color: "#0adcc0" }
                  : colorStyle === "processPt"
                  ? { fontSize: "16px", color: "#09A0F2" }
                  : colorStyle === "processPv"
                  ? { fontSize: "16px", color: "#FF5ECD" }
                  : { fontSize: "16px", color: "#ffdb5e" }
              }
            />
          </div>
          {/* {header.isPlaceholder
          ? null
          : flexRender(header.column.columnDef.header, header.getContext())} */}
          <div
            className={classes.title}
            style={
              colorStyle === "base"
                ? { color: "#0adcc0" }
                : colorStyle === "processPt"
                ? { color: "#09A0F2" }
                : colorStyle === "processPv"
                ? { color: "#FF5ECD" }
                : { color: "#ffdb5e" }
            }
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
          </div>
          <div
            className={classes.sortIcon}
            style={
              colorStyle === "base"
                ? { color: "#0adcc0" }
                : colorStyle === "processPt"
                ? { color: "#09A0F2" }
                : colorStyle === "processPv"
                ? { color: "#FF5ECD" }
                : { color: "#ffdb5e" }
            }
          >
            {{
              asc: <SortArrowUp />,
              desc: <SortArrowDown />,
            }[header.column.getIsSorted() as string] ?? <SortArrowUnset />}
          </div>
        </div>
        <div
          className={classes.filters}
          style={backColorTableHeader(user?.mode ?? "lite")}
        >
          {header.column.getCanFilter() ? (
            <div>
              <Filter column={header.column} table={table} header={header} />
            </div>
          ) : (
            <div>
              <input className={classes.defaultInput} disabled></input>
            </div>
          )}
        </div>
      </div>
    </th>
  );
};
